import {
  GET_CLEANING_MACHINE_UTILISATION_FAIL,
  GET_CLEANING_MACHINE_UTILISATION_REQUEST,
  GET_CLEANING_MACHINE_UTILISATION_SUCCESS
} from './action';
import * as queries from './queries';

export function fetchCleaningMachineUtilisationYear(payload) {
  const { isoYear } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_CLEANING_MACHINE_UTILISATION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getYearMachineUtilisation,
        variables: {
          isoYear
        }
      });
      const result = clientResponse?.data?.getYearMachineUtilisation;

      const list = {
        data: result
      };

      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_SUCCESS,
        payload: list
      });
    } catch (error) {
      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchCleaningMachineUtilisationMonth(payload) {
  const { isoYear, isoMonth } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_CLEANING_MACHINE_UTILISATION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getMonthMachineUtilisation,
        variables: {
          isoYear,
          isoMonth
        }
      });
      const result = clientResponse?.data?.getMonthMachineUtilisation;

      const list = {
        data: result
      };

      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_SUCCESS,
        payload: list
      });
    } catch (error) {
      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchCleaningMachineUtilisationWeek(payload) {
  const { isoYear, isoWeek } = payload;
  return async (dispatch, _, { client } = {}) => {
    try {
      dispatch({ type: GET_CLEANING_MACHINE_UTILISATION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getWeekMachineUtilisation,
        variables: {
          isoYear,
          isoWeek
        }
      });
      const result = clientResponse?.data?.getWeekMachineUtilisation;

      const list = {
        data: result
      };

      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_SUCCESS,
        payload: list
      });
    } catch (error) {
      dispatch({
        type: GET_CLEANING_MACHINE_UTILISATION_FAIL,
        payload: { error }
      });
    }
  };
}
